var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
/** Accordion leve (seta + título + contagem) usado em toda a página de Atualizações. */
function CollapsibleGroup(_a) {
    var title = _a.title, count = _a.count, _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b, _c = _a.level, level = _c === void 0 ? 0 : _c, children = _a.children;
    var _d = useState(defaultOpen), open = _d[0], setOpen = _d[1];
    return (_jsxs("div", __assign({ className: "settings-group settings-group-level-".concat(level, " ").concat(open ? "open" : "") }, { children: [_jsxs("button", __assign({ type: "button", className: "settings-group-header", onClick: function () { return setOpen(function (prev) { return !prev; }); }, "aria-expanded": open }, { children: [open ? _jsx(KeyboardArrowUpIcon, {}) : _jsx(KeyboardArrowDownIcon, {}), _jsx("span", __assign({ className: "settings-group-title" }, { children: title })), count !== undefined && _jsxs("span", __assign({ className: "settings-group-count" }, { children: ["(", count, ")"] }))] })), open && _jsx("div", __assign({ className: "settings-group-content" }, { children: children }))] })));
}
export default CollapsibleGroup;
